import styled from "styled-components";

import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton, Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { TeamListItem } from "../../types/teams.types";

const ActionsWrapper = styled(Flex)`
    opacity: 0;
    pointer-events: none;
    transition: opacity 120ms ease-in-out;

    .ant-table-row:hover &,
    &:focus-within {
        opacity: 1;
        pointer-events: auto;
    }
`;

type TeamsTableActionsCellProps = {
    team: TeamListItem;
    onEdit: (team: TeamListItem) => void;
    onDelete: (team: TeamListItem) => void;
};

export const TeamsTableActionsCell = ({ team, onEdit, onDelete }: TeamsTableActionsCellProps) => {
    const { translate } = useTranslate();

    return (
        <ActionsWrapper
            alignItems="center"
            gap="4px"
            margin="0 4px"
            data-automation={`teams-table-actions-${team.teamId}`}
        >
            <Tooltip content={translate("si.common.edit")}>
                <IconButton
                    type="flat"
                    iconName="edit-icon-fill"
                    iconSize="xs"
                    onClick={() => onEdit(team)}
                    dataAutomation={`teams-table-edit-${team.teamId}`}
                />
            </Tooltip>
            <Tooltip content={translate("si.common.button.delete")}>
                <IconButton
                    type="flat"
                    iconName="delete"
                    iconSize="xs"
                    onClick={() => onDelete(team)}
                    dataAutomation={`teams-table-delete-${team.teamId}`}
                />
            </Tooltip>
        </ActionsWrapper>
    );
};
